const ServerShift = () => import(/* webpackChunkName: "serverShift" */ '@/components/dashboard/serverShift')
export default {
    name: 'serverShift',
    path: 'server-shift',
    redirect: '/server-shift/index',
    meta: {label: 'serverShift'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'serverShift', auth: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]},
            component: ServerShift,
            props: true
        }
    ]
}
